import React from 'react';
import './Footer.scss';
import DisclaimerComponent from '@zappy-ride/disclaimer-footer-component';
import FooterTop from '../../../assets/images/Footer-top-border.svg';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="FooterTop-container">
          <img src={FooterTop} className="footer-top" alt="Footer Top" />
        </div>
        <div className="Footer">
          <div className="container">
            <div>
              <span className="disclaimer_container">
                <DisclaimerComponent
                  clientName="SMUD"
                  textStyle={{
                    fontFamily: 'Lato',
                    fontSize: '12px',
                    color: '#333333',
                  }}
                  imageStyle={{
                    display: 'none',
                  }}
                  wrapperStyle={{
                    padding: '0px',
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
